/**
 * @generated SignedSource<<3424acb514027a77e7891e4f27214fd2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sponsorTagSponsor$data = {
  readonly images: ReadonlyArray<{
    readonly url: string;
  } | null | undefined>;
  readonly name: string | null | undefined;
  readonly type: string | null | undefined;
  readonly " $fragmentType": "sponsorTagSponsor";
};
export type sponsorTagSponsor$key = {
  readonly " $data"?: sponsorTagSponsor$data;
  readonly " $fragmentSpreads": FragmentRefs<"sponsorTagSponsor">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "sponsorTagSponsor",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Image",
      "kind": "LinkedField",
      "name": "images",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "url",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Sponsor",
  "abstractKey": null
};

(node as any).hash = "3e8b747615d2786d19da6be2b24870c9";

export default node;
